import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './../services/services';
import 'rxjs/add/operator/publishReplay';

let headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/x-www-form-urlencoded');
let options = new RequestOptions({ headers: headers });	 

export class Page {
    constructor(public slug: string, public description: string,public title: string) { }
}

@Injectable()
export class PageService {

  
    public _pagemaindata;
    constructor(
      private http: Http,
      
      private shareService: ShareService) {
  
  
    }

	getPage(slug:string) {
	    //console.log(slug);
	    let page=[];
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/p/'+slug;
	  // 	if (!this._pagemaindata) { 	     
        let apidata = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  
             //page.push();
             page[slug] = apidata;
            console.log(JSON.stringify(page));
          //  }
         return apidata;
	}
	
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Page Server error');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/page/page.service.ts